<template>
  <div class="pagePassowrdEdit">
    <XR-head titleText="密码修改" :rightShow="false" ref="headObj"></XR-head>
    <div>      
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <mu-text-field label="旧密码" type="password" helpText="请输入旧密码" labelFloat fullWidth v-model="editInfo.password" />
        </mu-col>
      </mu-row>      
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <mu-text-field label="新密码" type="password" helpText="请输入您的新密码" labelFloat fullWidth v-model="editInfo.newPassword" />
        </mu-col>
      </mu-row>      
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <mu-text-field label="确认密码" type="password" helpText="请再次输入新密码" labelFloat fullWidth v-model="editInfo.confrimNewPassword" />
        </mu-col>
      </mu-row>    
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33" class="btn-div">          
          <mu-raised-button label="确 定" class="submit" primary fullWidth @click="submit()" />
        </mu-col>
      </mu-row>  
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <!-- <mu-flat-button label="忘记密码" to="/FindPasswordType" class="forgetBtn"></mu-flat-button> -->
          <mu-flat-button label="忘记密码" @click="goPhone"  class="forgetBtn"></mu-flat-button>
          
        </mu-col>
      </mu-row>   
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import md5 from 'js-md5'
export default {
  data () {
    return {
      editInfo:{
        password : '',
        newPassword:'',
        confrimNewPassword:''
      },
      isTestPhone:false,
    }
  },
  mounted(){
    this.getMemberInfo()
  },
  methods: {
    submit: function(){
      var ths = this;  
      
      if(!ths.editInfo.password){
          ths.$refs.XRtoast.failed('请输入旧密码', true)
          return
      }
      if(!ths.editInfo.newPassword){
          ths.$refs.XRtoast.failed('请输入新密码', true)
          return
      }
      if(ths.editInfo.newPassword != ths.editInfo.confrimNewPassword){
          ths.$refs.XRtoast.failed('二次输入的密码不一致', true)
          return
      }

      ths.$post(
        "/Shop/UserServer/ModifyPassword",
        JSON.stringify(this.editInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.editInfo.password =  ''
          ths.editInfo.newPassword =  ''
          ths.editInfo.confrimNewPassword = ''
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{
          ths.$router.goBack()
        }
      });
    },
    getMemberInfo(){
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
        ths.loaded =false          
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.hide()
          ths.isTestPhone = res.Data.IsTestPhone
        }
      });      
    },
    goPhone(){
      if(!this.isTestPhone){
          this.$refs.XRtoast.failed('您未绑定手机', true)
          return
      }
      this.$router.push("/findpassword")
    },
  }
}
</script>
<style>
.pagePassowrdEdit{
  background: white;
}
.pagePassowrdEdit .rowFiled{
  padding: 0 5%;
}
.pagePassowrdEdit .forgetBtn {
  float: right;
}

.pagePassowrdEdit .btn-div {
  padding: 40px 5% 30px;
}
.pagePassowrdEdit .submit {
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/passwordEdit.vue